
import Vue from 'vue';

export default Vue.extend({
  name: 'Loader',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    dialog: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 50
    }
  },
  computed: {
    mode (): string {
      if (this.block) return 'block';
      else if (this.inline) return 'inline';
      else return 'dialog';
    }
  }
});
